import moment from 'moment';

const checkUpdateTimeDifference = (updateDate) => {
  if (updateDate) {
    const updatedTime = moment(updateDate);
    const currentTime = moment(Date.now());
    const timeDifference = currentTime.diff(updatedTime, 'minute');
    return timeDifference > 1 ? true : false;
  }
  return false;
};

export default checkUpdateTimeDifference;
